const { REACT_APP_BASE_URL_ELASTICSEARCH, REACT_APP_BASE_URL_ZEVI_AI, REACT_APP_BUCKET_ZEVI_AI } =
  process.env;

const searchService = {
  searchZevi(store, query, sort, filters = {}, page = 1, limit = 25) {
    const filterString = Object.keys(filters)
      .map((val) => filters[val])
      .filter((val) => val.length > 0)
      .join("&");
    const sortArray = sort.value.split("|");
    const sortqueryParams = "sort_by=${sortArray[0]}&sort_order=${sortArray[1]}";

    return fetch(
      `${REACT_APP_BASE_URL_ZEVI_AI}?q=${query}&store=${store}&${filterString}&${
        REACT_APP_BUCKET_ZEVI_AI ? `bucket=${REACT_APP_BUCKET_ZEVI_AI}&` : ""
      }limit=${limit}&pageno=${page}`,
    ).then((response) => response.json());
  },

  searchElasticSearch(store, query, sort, filters = {}, page = 1, limit = 25) {
    const filterString = Object.keys(filters)
      .map((val) => filters[val])
      .filter((val) => val.length > 0)
      .join("&");
    const sortArray = sort.value.split("|");

    return fetch(
      `${REACT_APP_BASE_URL_ELASTICSEARCH}?q=${query}&store=${store}&${filterString}&limit=${25}&usecache=True&&pageno=${page}&sort_by=${
        sortArray[0]
      }&sort_order=${sortArray[1]}`,
    ).then((response) => response.json());
  },
};

export default searchService;

//https://staging.search.zevi.in/search-2?limit=25&store=azeem-test-2.myshopify.com&usecache=True&q=oil (oziva poc simple search)
//https://hinglish.search.zevi.in/search/?store=azeem-test-2.myshopify.com&bucket=model:hinglish&q=vitamin (oziva poc ai search)

/**
 * https://staging.search.zevi.in/search-2?limit=25&store=virgio4&usecache=True&q=o (virgio poc simple search)
https://virgio.search.zevi.in/search/?store=virgio4&limit=100&q=j (virgio poc ai search)
https://staging.search.zevi.in/search-2?limit=25&store=azeem-test-2.myshopify.com&usecache=True&q=oil (oziva poc simple search)
https://hinglish.search.zevi.in/search/?store=azeem-test-2.myshopify.com&bucket=model:hinglish&q=vitamin (oziva poc ai search)
 */

//https://search.zevi.in/search?q=a&store=jinu09.myshopify.com&limit=12&pageno=1&filter=price=31-80&sort_by=relevance&sort_order=desc
